module.exports = __webpack_public_path__ + "img/Knuddeln.5c116feb.jpg";